import React, { Fragment } from 'react';
import { FaPlay } from 'react-icons/fa6';
import RelatedBooks from '../Home/RelatedBooks';
import AudioBooksChapters from './AudioBookChapters';
import BooksChapters from './BooksChapters';
import useBooks from '../../Hooks/Books/useBooks';
import { ProgressBar } from 'react-bootstrap';



const BooksDetails = () => {

    const {
        item,
        checkSubs,
        bookschap,
        read,
        setRead
    } = useBooks();

    return (
        <Fragment>


            <div className="container px-5 my-5 book-detail">
                <div className={`${read ? "" : "align-items-center"} row justify-content-around`}>
                    {!read ? (
                        <>
                            <div className="col-lg-auto" >
                                <div
                                    style={{ backgroundImage: `url(${item?.book_img})` }}

                                    className="background-image-blur card position-relative p-4 book-detail-card  d-flex justify-content-center border-0 align-items-center" >


                                    <div className="foreground-content">
                                        <img className="detail-image" src={item?.book_img} alt="" />

                                        {item?.book_type != "book" && (
                                            <button className="play-pause-button">
                                                <FaPlay size={22} />
                                            </button>
                                        )}

                                        {item?.book_type != "book" && (

                                            <div className="progress-bar-container">
                                                <ProgressBar style={{ height: "10px" }} variant="danger" now={item?.book_progress} />
                                            </div>
                                        )}

                                    </div>
                                </div>


                            </div>

                            <div className="col-lg-6">
                                <h2 className='s-30 fw-600 mb-3'>
                                    {item?.title}
                                </h2>

                                <p className='fw-300'>
                                    {item?.description}
                                </p>


                                {checkSubs?.status != 1 && (

                                    <div className="bg-light rounded-3 my-4" style={{ width: "fit-content" }}>
                                        <div className="row justify-content-center">
                                            <div className="col-auto">
                                                <h4 className='s-21 p-3 fw-600 mb-0 '>Price {" "} <span className='s-16 fw-400'> ${item?.price}</span></h4>
                                            </div>


                                            <div className="col-auto">
                                                <h4 className='s-21 p-3 fw-600 mb-0 '>Chapters {" "} <span className='s-16 fw-400'> {item?.chapter_count}</span></h4>
                                            </div>

                                        </div>

                                    </div>
                                )}

                                <hr />


                                {
                                    checkSubs?.status === 1 ? (
                                        <>
                                            <div className="col-auto">
                                                <button onClick={() => setRead(true)} className='btn btn-dark px-4 py-2'>

                                                    {item?.book_type != "book" ? "Listen" : "Read"}

                                                </button>
                                            </div>
                                        </>
                                    ) :

                                        (
                                            <>
                                                <div className="row mt-4">
                                                    <div className="col-auto">
                                                        <button onClick={() => setRead(true)} className='btn btn-dark px-4 py-2'>
                                                            {item?.book_type != "book" ? "Listen first chapter" : "   Read first chapter"}


                                                        </button>
                                                    </div>
                                                    <div className="col-auto">
                                                        <button className='btn btn-danger px-4 py-2'>Subscribe to read</button>
                                                    </div>

                                                </div>
                                            </>
                                        )
                                }

                            </div>

                        </>

                    ) : (

                        <div className="col-lg-12">
                            {
                                item?.book_type === "book" ? (
                                    < BooksChapters checkSubs={checkSubs} bookschap={bookschap || []} />
                                ) : (
                                    <>
                                        <AudioBooksChapters checkSubs={checkSubs} bookschap={bookschap || []} />
                                    </>

                                )
                            }
                        </div>

                    )}

                </div>
            </div>



            <div className="bg-light my-5">
                <div className="container px-4">
                    <div className="row justify-content-around">
                        <div className="col-11 py-100">
                            <h3 className='text-danger s-30 fw-600 mb-3'>Author: <span className='text-dark s-30 fw-600'>By {item?.author_name}</span></h3>

                            <p className='fw-400'>
                                {item?.description}
                            </p>
                        </div>
                    </div>
                </div>
            </div>



            <RelatedBooks title={"Related Books"} background={"transparent"} />
        </Fragment >
    )
}

export default BooksDetails